'use client';

import { useBuildVersion } from '@payments-checkout/shared/helpers/hooks/useBuildVersion';
import { usePreventIOSZoom } from '@payments-checkout/shared/helpers/hooks/usePreventIOSZoom';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';
import { QueryProvider } from '@payments-checkout/shared/providers';

const TranslationProvider = dynamic(
  () =>
    import('@payments-checkout/checkout').then(
      (module) => module.TranslationProvider
    ),
  { ssr: true }
);

const Header = dynamic(
  () => import('@payments-checkout/checkout').then((module) => module.Header),
  { ssr: false, loading: () => null }
);

export function RootProviders({ children }: { children: ReactNode }) {
  // No provider raiz para valer em toda rota, inclusive 404 e tela de erro.
  useBuildVersion();
  usePreventIOSZoom();

  return (
    <QueryProvider>
      <TranslationProvider>
        <Header />
        {children}
      </TranslationProvider>
    </QueryProvider>
  );
}
